import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Nlayout from './Nlayout';
import './Rankings.css';
import { FaCrown, FaSearch, FaArrowLeft, FaRegCalendarAlt } from 'react-icons/fa';
import coinImg from './Wild_coin.png';

// Fallback avatar generator
const getAvatarUrl = (username) => {
    return `https://api.dicebear.com/7.x/identicon/svg?seed=${encodeURIComponent(username)}`;
};

export default function DetalleRanking() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [rankingData, setRankingData] = useState(null);
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const obtenerRankingPorId = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`https://backend.eldenguee.com/torneos/ranking/${id}`);
            setRankingData(res.data);

            // Extract ranking list
            let rawList = [];
            if (res.data) {
                if (Array.isArray(res.data)) {
                    rawList = res.data;
                } else {
                    rawList = res.data.usuarios ||
                        res.data.ranking ||
                        res.data.participantes ||
                        res.data.data ||
                        res.data.recordset ||
                        [];
                }
            }

            // Standardize and sort descending by messages
            const processedList = rawList
                .map(item => ({
                    username: item.userName || item.user_name || item.username || item.nombre || item.name || 'Desconocido',
                    mensajes: parseInt(item.mensajes || item.cantidad || item.puntos || item.points || item.score || 0, 10),
                    profile: item.profile_picture || item.profile || item.avatar || item.image || item.foto
                }))
                .sort((a, b) => b.mensajes - a.mensajes);

            setUsuarios(processedList);
        } catch (error) {
            console.error(`Error al obtener el ranking con ID ${id}:`, error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerRankingPorId();
    }, [id]);

    // Filter by username search input
    const usuariosFiltrados = usuarios.filter(user =>
        user.username.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // podium data
    const firstPlace = usuarios.length > 0 ? usuarios[0] : null;
    const secondPlace = usuarios.length > 1 ? usuarios[1] : null;
    const thirdPlace = usuarios.length > 2 ? usuarios[2] : null;

    // Remaining users
    const tableUsers = usuariosFiltrados.filter((user, index) => {
        // Find correct index in original array to keep rank
        const originalIndex = usuarios.findIndex(u => u.username === user.username);
        return originalIndex >= 3;
    });

    const formatRankingDate = () => {
        if (!rankingData) return 'Cargando...';
        const fechaRaw = rankingData.fecha || rankingData.fecha_creacion || rankingData.createdAt;
        if (!fechaRaw) return `Ranking ID: ${id}`;
        try {
            const date = new Date(fechaRaw);
            if (isNaN(date.getTime())) return fechaRaw;
            return `Stream del ${date.toLocaleDateString('es-ES', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        } catch (e) {
            return `Ranking ID: ${id}`;
        }
    };

    return (
        <Nlayout>
            <div className="rankings-container">
                <div className="rankings-content">
                    <button className="btn-back-rankings" onClick={() => navigate(-1)}>
                        <FaArrowLeft /> Volver atrás
                    </button>

                    <div className="rankings-header" style={{ textAlign: 'left', marginBottom: '32px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                            <span className="ranking-badge-status archived" style={{ fontSize: '0.85rem', padding: '6px 14px' }}>
                                Ranking Archivado
                            </span>
                            <span style={{ color: 'rgba(255,255,255,0.4)', fontFamily: 'monospace', fontSize: '0.9rem' }}>
                                ID: {id}
                            </span>
                        </div>
                        <h1 className="rankings-title" style={{ textAlign: 'left', marginTop: '16px', fontSize: '2.5rem' }}>
                            Detalle de Clasificación
                        </h1>
                        <p className="rankings-subtitle" style={{ textAlign: 'left', margin: '8px 0 0' }}>
                            <FaRegCalendarAlt style={{ marginRight: '8px', color: '#807ffb', verticalAlign: 'middle' }} />
                            <span style={{ verticalAlign: 'middle' }}>{formatRankingDate()}</span>
                        </p>
                    </div>

                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                            <div className="loader-spinner" style={{
                                width: '45px',
                                height: '45px',
                                border: '4px solid rgba(255, 255, 255, 0.1)',
                                borderTop: '4px solid #807ffb',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }} />
                        </div>
                    ) : usuarios.length === 0 ? (
                        <div className="rankings-rules-card" style={{ textAlign: 'center', padding: '50px 20px' }}>
                            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '1.2rem', margin: 0 }}>
                                No se encontraron datos ni mensajes registrados para este ranking.
                            </p>
                        </div>
                    ) : (
                        <>
                            {/* Podium (Top 3) */}
                            <div className="podium-container">
                                {/* 2nd Place */}
                                {secondPlace && (
                                    <div className="podium-card rank-2">
                                        <div className="podium-avatar-wrapper">
                                            <img
                                                src={secondPlace.profile || getAvatarUrl(secondPlace.username)}
                                                alt={secondPlace.username}
                                                className="podium-avatar"
                                            />
                                            <span className="podium-badge">2</span>
                                        </div>
                                        <div className="podium-username">{secondPlace.username}</div>
                                        <div className="podium-messages">
                                            Mensajes: <span className="podium-messages-count">{secondPlace.mensajes}</span>
                                        </div>
                                        <div className="podium-reward">
                                            🎟️ Tipeo 1xbet
                                        </div>
                                    </div>
                                )}

                                {/* 1st Place */}
                                {firstPlace && (
                                    <div className="podium-card rank-1">
                                        <FaCrown className="podium-crown" style={{ color: '#fdb813' }} />
                                        <div className="podium-avatar-wrapper">
                                            <img
                                                src={firstPlace.profile || getAvatarUrl(firstPlace.username)}
                                                alt={firstPlace.username}
                                                className="podium-avatar"
                                            />
                                            <span className="podium-badge">1</span>
                                        </div>
                                        <div className="podium-username">{firstPlace.username}</div>
                                        <div className="podium-messages">
                                            Mensajes: <span className="podium-messages-count">{firstPlace.mensajes}</span>
                                        </div>
                                        <div className="podium-reward" style={{ borderColor: 'rgba(253, 184, 19, 0.4)', color: '#fdb813' }}>
                                            👑 Tipeo 1xbet
                                        </div>
                                    </div>
                                )}

                                {/* 3rd Place */}
                                {thirdPlace && (
                                    <div className="podium-card rank-3">
                                        <div className="podium-avatar-wrapper">
                                            <img
                                                src={thirdPlace.profile || getAvatarUrl(thirdPlace.username)}
                                                alt={thirdPlace.username}
                                                className="podium-avatar"
                                            />
                                            <span className="podium-badge">3</span>
                                        </div>
                                        <div className="podium-username">{thirdPlace.username}</div>
                                        <div className="podium-messages">
                                            Mensajes: <span className="podium-messages-count">{thirdPlace.mensajes}</span>
                                        </div>
                                        <div className="podium-reward" style={{ borderColor: 'rgba(205, 127, 50, 0.4)', color: '#cd7f32' }}>
                                            🎟️ Tipeo 1xbet
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Search Bar */}
                            <div className="rankings-controls">
                                <div style={{ position: 'relative', flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type="text"
                                        className="rankings-search-input"
                                        placeholder="Buscar un participante por nombre..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        style={{ paddingLeft: '45px' }}
                                    />
                                    <FaSearch style={{ position: 'absolute', left: '18px', color: 'rgba(255,255,255,0.3)' }} />
                                </div>
                            </div>

                            {/* Remaining Users Table */}
                            {tableUsers.length > 0 ? (
                                <div className="rankings-table-container">
                                    <table className="rankings-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '60px' }}>Puesto</th>
                                                <th>Usuario</th>
                                                <th>Mensajes</th>
                                                <th style={{ textAlign: 'right' }}>Recompensa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableUsers.map((user) => {
                                                const originalIndex = usuarios.findIndex(u => u.username === user.username);
                                                const rank = originalIndex + 1;
                                                const hasReward = rank <= 20;

                                                return (
                                                    <tr key={user.username}>
                                                        <td className={`cell-rank ${hasReward ? 'in-reward' : ''}`}>
                                                            #{rank}
                                                        </td>
                                                        <td>
                                                            <div className="cell-user">
                                                                <img
                                                                    src={user.profile || getAvatarUrl(user.username)}
                                                                    alt={user.username}
                                                                    className="cell-user-avatar"
                                                                />
                                                                <span className="cell-username">{user.username}</span>
                                                            </div>
                                                        </td>
                                                        <td className="cell-messages">
                                                            <span className="cell-messages-count">{user.mensajes}</span>
                                                            <span className="cell-messages-label"> msjs</span>
                                                        </td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            <span className={`cell-reward-badge ${hasReward ? 'coins' : 'none'}`}>
                                                                {hasReward ? (
                                                                    <>
                                                                        <img src={coinImg} style={{ width: '14px', height: '14px' }} alt="Coin" />
                                                                        <span>D-Coins</span>
                                                                    </>
                                                                ) : (
                                                                    'Sin premio'
                                                                )}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : searchTerm && (
                                <div className="rankings-rules-card" style={{ textAlign: 'center', padding: '30px 20px' }}>
                                    <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '1.1rem', margin: 0 }}>
                                        No se encontraron resultados para "{searchTerm}".
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </Nlayout>
    );
}
